






















































import { Component, Vue, Prop, PropSync, Watch } from "vue-property-decorator";
import DxScrollView from "devextreme-vue/scroll-view";
import { DxDropDownBox } from "devextreme-vue/drop-down-box";
import { DxCheckBox } from "devextreme-vue/check-box";

interface NodeType {
  name: string;
  id: string;
  strong_tariff_calc: boolean;
  check: boolean;
  disabled: boolean;
}

interface CutsList {
  year_id: string;
  year_name: number;
  nodes: NodeType[];
}

@Component({
  name: "CutsTreeDropDownBox",
  components: { DxScrollView, DxDropDownBox, DxCheckBox }
})
export default class CutsTreeDropDownBox extends Vue {
  @PropSync("selection", { type: Array }) public cutsList!: CutsList[];
  @Prop({ default: false }) public disabled!: boolean;
  @Prop({ default: null }) public value!: string | null;
  @Prop({ default: "217px"}) public styleWidth!: string;
  @Prop({ default: "100%"}) public popupWidth!:string;

  private isDropDownOpen = false;
  private expandedYears: { [id: string]: boolean } = {};
  private selectedNodeId: string | null = null;

  mounted() {
    // Восстанавливаем выбор из пропса value
    if (this.value) {
      this.selectedNodeId = this.value;
      this.expandYearForNode(this.value); // Автоматически раскрываем нужный год
      this.syncNodeSelection();
      // ГАРАНТИРУЕМ, что при восстановлении эмитится событие
      this.$nextTick(() => {
        this.$emit("input", this.value);
        this.$emit("cut-restored", this.value);
      });
    }
  }

  get dropDownData(): string[] {
    return this.displayValue ? [this.displayValue] : [];
  }

  isYearExpanded(yearId: string) {
    return !!this.expandedYears[yearId];
  }

  toggleYear(yearId: string) {
    this.$set(this.expandedYears, yearId, !this.isYearExpanded(yearId));
  }


  /**
   * Находит и раскрывает год, содержащий заданный узел
   */
  private expandYearForNode(nodeId: string) {
    if (!this.cutsList) return;
    
    for (const year of this.cutsList) {
      const nodeExists = year.nodes.some(node => node.id === nodeId);
      if (nodeExists) {
        this.$set(this.expandedYears, year.year_id, true);
        break;
      }
    }
  }


  /**
   * Закрывает все остальные годы, кроме того, в котором выбран узел
   */
  private collapseOtherYears(yearIdToKeepOpen: string) {
    if (!this.cutsList) return;
    
    for (const year of this.cutsList) {
      if (year.year_id !== yearIdToKeepOpen) {
        this.$set(this.expandedYears, year.year_id, false);
      }
    }
  }


  isNodeSelected(nodeId: string): boolean {
    return this.cutsList.some(year =>
      year.nodes.some(node => node.id === nodeId && node.check)
    );
  }

  onNodeCheckChanged(yearId: string, node: NodeType, e: any) {
    const isChecked = e.value;

    if (isChecked) {
      this.selectedNodeId = node.id;
      // Раскрываем текущий год и закрываем остальные
      this.expandYearForNode(node.id);
      this.collapseOtherYears(yearId);
    } else if (this.selectedNodeId === node.id) {
      this.selectedNodeId = null;
    }

    this.syncNodeSelection();
    this.$emit("input", this.selectedNodeId);
    this.isDropDownOpen = true;
  }


  private syncNodeSelection() {
    if (!this.cutsList) return;

    for (const year of this.cutsList) {
      for (const node of year.nodes) {
        node.check = node.id === this.selectedNodeId;
      }
    }
  }


  private clearAllChecks() {
    (this.cutsList || []).forEach(year => {
      (year.nodes || []).forEach(node => {
        node.check = false;
      });
    });
  }

  @Watch("value")
  private onValueChanged(newVal: string | null) {
    console.log("newVal", newVal)
    if (newVal !== this.selectedNodeId) {
      this.selectedNodeId = newVal;
      if (newVal) {
        // Автоматически раскрываем год с новым значением
        this.expandYearForNode(newVal);
        this.collapseOtherYears(this.getYearIdForNode(newVal));
      } else {
        // Если значение null, закрываем все
        this.expandedYears = {};
      }
      this.syncNodeSelection();
    }
  }

  private getYearIdForNode(nodeId: string): any {
    if (!this.cutsList) return;
    
    for (const year of this.cutsList) {
      const nodeExists = year.nodes.some(node => node.id === nodeId);
      if (nodeExists) {
        return year.year_id;
      }
    }
    return null;
  }

  @Watch("cutsList", { deep: true })
  private onCutsListChanged() {
    this.$nextTick(() => {
      this.syncNodeSelection();
      
      if (this.selectedNodeId) {
        const yearId = this.getYearIdForNode(this.selectedNodeId);
        if (yearId) {
          this.collapseOtherYears(yearId);
          this.expandYearForNode(this.selectedNodeId);
        }
      }
    });
  }

  get displayValue(): string | null {
    if (!this.selectedNodeId) return null;

    for (const year of this.cutsList) {
      const node = year.nodes.find(n => n.id === this.selectedNodeId);
      if (node) return `${year.year_name}: ${node.name}`;
    }
    return null;
  }


  onSelectBoxChanged(e: any) {
    if (e && e.value === null) {
      this.selectedNodeId = null;
      this.expandedYears = {}; 
      this.clearAllChecks(); 
      this.$emit("input", null);
    }
  }
}
